<span
	*ngIf="disableHeaderTag || (h1TitleExists$ | async); else showH1Tag"
	[innerHTML]="content"
	class="obg-seo-tag-text"
></span>
<ng-template #showH1Tag>
	<h1 [innerHTML]="content" class="obg-seo-tag-text"></h1>
</ng-template>
